module.exports = __webpack_public_path__ + "static/img/item8@2x.25a938dd.png";